import { render, staticRenderFns } from "./MonthStockValue.vue?vue&type=template&id=d4e801be&"
import script from "./MonthStockValue.vue?vue&type=script&lang=js&"
export * from "./MonthStockValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports